import React from "react";
import { usePermissions } from "../../hooks/usePermissions";
import { addEstimateLocation, updateEstimateLocation } from "../../helpers/estimates";
import { WorkspaceNameSheet } from "../workspace/WorkspaceNameSheet";

/**
 * Lightweight Add/Rename Location entry — a single name field.
 * Persistence stays on addEstimateLocation/updateEstimateLocation.
 */
export function LocationNameSheet({
  estimateId,
  sortOrder,
  location = null,
  onClose,
  onSaved,
}) {
  const { actor } = usePermissions();

  async function handleSubmit(trimmed) {
    if (location) {
      await updateEstimateLocation(actor, location.room_id, { name: trimmed });
    } else {
      await addEstimateLocation(actor, estimateId, trimmed, sortOrder);
    }
    await onSaved?.();
  }

  return (
    <WorkspaceNameSheet
      title={location ? "Rename Location" : "Add Location"}
      fieldLabel="Location Name"
      placeholder="Master Bathroom"
      initialName={location?.name || ""}
      primaryLabel={location ? "Save Changes" : "Add Location"}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
}
